export const ROLE_SUPER_ADMIN = 'SuperAdmin';
export const ROLE_ADMIN = 'Admin';
export const ROLE_COORDINATOR = 'Coordinator';
